module.exports = __webpack_public_path__ + "static/img_pledge_effect_01@2x-073abe149c788fd2fdaecc8992a43f5c.png";